<div id="site" class="center-vertical d-flex flex-column mh-100vh">
  
  <div class="d-flex align-items-center error-container">

    <div class="container">

      <div class="row align-items-center">

        <div class="col-12 col-md-8 offset-md-2 col-xl-8 offset-xl-2">

          <div class="row align-items-center">

            <div class="col-md-8">

              <!-- Heading -->
              <h1 class="mb-5">
                Oh nein! Es ist ein Fehler aufgetreten
              </h1>

              <!-- Subheading -->
              <p class="mb-5 lead">
                Das sollte eigentlich nicht passieren. Bitte helfen Sie uns und senden Sie uns die Fehlermeldung.
              </p>

              <a href="mailto:info@engidesk.com" class="btn btn-primary">
                Fehlermeldung senden
              </a>

            </div>

          </div> <!-- / .row -->
        </div>
      </div><!-- / .row -->
    </div><!-- / .container -->
  </div>
</div>